import { render } from "./commonIndex.vue?vue&type=template&id=476973a1&scoped=true"
import script from "./commonIndex.vue?vue&type=script&lang=js"
export * from "./commonIndex.vue?vue&type=script&lang=js"

import "./commonIndex.vue?vue&type=style&index=0&id=476973a1&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476973a1"]])

export default __exports__